import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course05 from "../../../course/course-05/course";
import lesson0517 from "../lesson-17/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "239668d4-6362-4432-8d73-031fdab3728b",
    course: { id: course05.id, slug: course05.slug as string, name: course05.name, publicId: course05.publicId },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0517),
    lesson: lesson0517,
  },
];

export default lessonLinks;
